export default __webpack_public_path__ + "static/media/icon-router.08f17c7d.svg";